module.exports = __webpack_public_path__ + "static/media/AccountNavIcon.6d095328.svg";